module.exports = __webpack_public_path__ + "static/media/match-notif.fbb79471.png";